<template>
  <div>
    <slot></slot>
    <strong v-if="props.errors[props.name]!=undefined" class="text-sm text-rose-600">
      {{ getError() }}
    </strong>
  </div>
</template>

<script setup>
const props = defineProps(['errors', 'name'])

const getError = () => {
  return props.errors[props.name][0]
}
</script>
